export default {
    firebaseConfig: {
        apiKey: "AIzaSyDv0fYtGYs39FmakBceqQsR6tBS73IUYMg",
        authDomain: "mevu-base.firebaseapp.com",
        databaseURL: "https://mevu-base.firebaseio.com",
        projectId: "mevu-base",
        storageBucket: "mevu-base.appspot.com",
        messagingSenderId: "227022270355"
    }
}

export const ADDRESS_MEVU = "0x03626c864162046779642db7ccda47ceb88312e5";
export const REWARDS_ADDRESS = '0xa10db8b4d041848102ef1ed526683f15f0b32cfe'
export const ADDRESS_MVU_TOKEN = "0x19e6c9445922d9d6e95eac0cc644a90ecd60f3c0";
export const ADDRESS_ORACLES_CONTROLLER = "0x9404afc41dd6ea2a9ab746b02cb5be2ea67f87fc";

export const FIREBASE_AUTH_CONTAINER = 'firebaseui-auth-container'

// Accounts

export const ACCOUNT_MEVU = "0x25a9f7512f28265Cb2772dE07DD947F969E19F49";


// WEBPACK FOOTER //
// ./src/config.js